import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OneClickPurchaseInfo } from '../../model/one-click-purchase-info';

@Component({
    selector: 'pme-one-click-purchase',
    templateUrl: './one-click-purchase.component.html',
    styleUrls: ['./one-click-purchase.component.scss'],
    standalone: false
})
export class OneClickPurchaseComponent implements OnInit {

  @Input() isEnd: boolean = false;
  @Input() show: boolean = false;
  @Input() elementIndex: number;
  @Input() idElement: string;
  @Input() oneClickPurchaseInfo: OneClickPurchaseInfo;
  @Output() clickEvent = new EventEmitter<{ changePayment: boolean, elementIndex: number }>();

  isMobile = /mobile|android|iphone|ipad|ipod|blackberry|windows phone/.test(navigator.userAgent.toLowerCase());

  oldLeft: number = 0;
  settedClass: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (this.oneClickPurchaseInfo && this.oneClickPurchaseInfo.cardNumber) {
      
      const parts = this.oneClickPurchaseInfo.cardNumber.split(" ");
      const lastFourDigits = parts[parts.length - 1];
      this.oneClickPurchaseInfo.cardNumber = `---- ${lastFourDigits}`;
    }

    try {
      this.getBaloonPosition();
    } catch (e) {
    }
  }

  ngOnChanges(): void {
    if (this.show) {
      try {
        this.getBaloonPosition();
      } catch (e) {
      }

    }
  }

  changePayment() {
    this.clickEvent.emit({ changePayment: true, elementIndex: this.elementIndex });
  }

  purchase() {
    this.clickEvent.emit({ changePayment: false, elementIndex: this.elementIndex });
  }

  getBaloonPosition() {
    if (this.isMobile) {
      return;
    }

    // Simulando posição do botão na tela
    let button = document.getElementById(this.idElement);

    let rect = button.firstElementChild.getBoundingClientRect();

    const screenWidth = window.innerWidth;
    if (this.settedClass) {

      if (this.oldLeft != rect.left) {
        button.firstElementChild.classList.remove('removeAlignLeft');
        button.firstElementChild.classList.remove('removeAlignRight');
        this.settedClass = false;
        this.oldLeft = rect.left;
      } else {

        return;
      }
    }



    if ((rect.left) <= 30) {

      button.firstElementChild.classList.add('removeAlignLeft');
      this.settedClass = true;
    } else {
      if ((rect.right + 20) >= (screenWidth - 30)) {
        button.firstElementChild.classList.add('removeAlignRight');
        this.settedClass = true;
      } else {
      }
    }

    button = document.getElementById(`oneClickPurchase${this.elementIndex}`);

    rect = button.firstElementChild.getBoundingClientRect();

    this.oldLeft = rect.left;
  }
}
